module.exports = __webpack_public_path__ + "img/clogo.7158395a.png";